var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete_outline_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17003",
    "data-name": "Path 17003",
    d: "M0,0H60V60H0Z",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10781",
    "data-name": "Rectangle 10781",
    width: 27,
    height: 30,
    transform: "translate(17 20)",
    fill: "#f74242",
    opacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17004",
    "data-name": "Path 17004",
    d: "M7.771,45.024a5.419,5.419,0,0,0,5.542,5.253H35.482a5.419,5.419,0,0,0,5.542-5.253V13.506H7.771Zm5.542-26.265H35.482V45.024H13.313ZM34.1,5.627,31.326,3H17.47L14.7,5.627H5V10.88H43.8V5.627Z",
    transform: "translate(5.602 3.361)",
    fill: "#f74242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete-2.e7960f9d.svg";
export { ForwardRef as ReactComponent };